import Operation from './Operation';

export default function IntersectLines(props) {
  return (<Operation {...props}>
  IntersectLines
  </Operation>);
};
